import { createClientLogger } from "@azure/logger";
export const logger = createClientLogger("core-http");
